module.exports = __webpack_public_path__ + "static/img/img_background_m.5337a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/bsop/img_background_m.jpg
// module id = QH0d
// module chunks = 0